import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from "react-router-dom";
import AppProviderWrapper from "./AppProviderWrapper";
import * as serviceWorker from './serviceWorker';
import './index.css';

ReactDOM.render(
    <React.StrictMode>
      <BrowserRouter>
        <AppProviderWrapper />
      </BrowserRouter>
    </React.StrictMode>,
    document.getElementById("root")
  );
  serviceWorker.unregister();
